export default {"src":"/_next/static/media/ic_check_green_paid_leagues.783b4707.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};